import React from "react";
import './class-engagement.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";

class ClassEngagement extends React.Component {

    state = {
        classList: [],
        selectedIndex: -1,
        showSections: false,
        showSectionsList: []

    }

    classWiseCompletionDetails = {}
    classSectionWiseCompletionDetails = {}

    constructor(props) {
        super(props)
        this.state = {
            classList: this.props.classList,
            showSectionsList: [],
            sectionsList: [{ title: 'A' }, { title: 'B' }, { title: 'C' }]
        }

        this.classWiseCompletionDetails = this.props.classWiseCompletionDetails
        this.classSectionWiseCompletionDetails = this.props.classSectionWiseCompletionDetails

    }


    back() {
        this.props.back && this.props.back()
    }

    showSectionsList(index) {
        let showSectionsList = this.state.showSectionsList
        this.state.classList.forEach((concept, idx) => {
            if (idx !== index) {
                showSectionsList[idx] = false
            }
        })
        showSectionsList[index] = showSectionsList[index] ? false : true

        this.setState({ showSectionsList, selectedIndex: index })
    }

    render() {
        return (
            <div className="class-engagement-list">
                <div ><img className="back-icon cursor-pointer" onClick={() => this.back()} src={getImageSource(ImageConstants.BACK_ICON)} /></div>
                <div className="d-flex align-items-center mt-3">
                    <img className="suitcase-icon mr-2" src={getImageSource(ImageConstants.BLACK_SUITCASE_ICON)} />
                    <span className="class-engagement-title">Class Engagement</span>
                </div>
                <div className="mt-3 table-wrapper">
                    <table className="table table-bordered" style={{ border: 'none' }}>
                        <thead className="class-header">
                            <tr className="first-header-bg">
                                <th className="border-top-left-radius">Class</th>
                                <th>#Assignment</th>
                                <th className="border-top-right-radius">Completion Rate</th>
                            </tr>
                        </thead>
                        <tbody id="rows" className="class-body">
                            {
                                this.state.classList && this.state.classList.length && this.state.classList.map((item, index) => (
                                    <>
                                        <tr>
                                            <td className={`cursor-pointer ${this.state.classList.length - 1 === index ? 'border-bottom-left-radius' : ''}  `}
                                                onClick={() => this.showSectionsList(index)}>
                                                <div className="d-flex align-items-center">
                                                    {
                                                        this.classSectionWiseCompletionDetails[item.title] && this.classSectionWiseCompletionDetails[item.title].length &&
                                                        <img className="angle-arrow mr-2" src={getImageSource(this.state.showSectionsList.length && this.state.showSectionsList[index] && this.state.selectedIndex === index ? ImageConstants.CIRCLE_UP_ARROW : ImageConstants.CIRCLE_DOWN_ARROW)} />
                                                    }

                                                    <span className="class-text">{item.title}</span>
                                                </div>
                                            </td>
                                            {

                                            }
                                            <td className="assignment-count">
                                                {this.classWiseCompletionDetails[item.title] ? this.classWiseCompletionDetails[item.title].totalSchoolwork : 0}
                                            </td>
                                            <td className="assignment-count">
                                                {`${this.classWiseCompletionDetails[item.title] ? this.classWiseCompletionDetails[item.title].classCompletionRate : 0}%`}
                                            </td>
                                        </tr>
                                        {
                                            this.state.showSectionsList.length &&
                                                this.state.showSectionsList[index] && this.state.selectedIndex === index &&
                                                this.classSectionWiseCompletionDetails[item.title] && this.classSectionWiseCompletionDetails[item.title].length ?
                                                this.classSectionWiseCompletionDetails[item.title].map(sectionItem => (
                                                    <tr>
                                                        <td className="assignment-count">
                                                            {sectionItem.section}
                                                        </td>
                                                        <td className="assignment-count">
                                                            {sectionItem.totalSchoolwork}
                                                        </td>
                                                        <td className="assignment-count">
                                                            {`${sectionItem.classSectionCompletionRate}%`}
                                                        </td>
                                                    </tr>
                                                ))
                                                :
                                                <></>
                                        }
                                    </>


                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

}

export default ClassEngagement;